module.exports = __webpack_public_path__ + "img/3.01.thmb.ee34670f.jpg";